const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  message: "",
};

const alertSlice = createSlice({
  name: "alert",
  initialState,
  reducers: {
    setAlertMessage: (state, action) => {
      state.message = action.payload;
    },
    clearAlertMessage: (state) => {
      state.message = "";
    },
  },
});

export const { setAlertMessage, clearAlertMessage } = alertSlice.actions;
export const selectAlertMessage = (state) => state.alert.message;

export default alertSlice.reducer;
